import { useI18n } from "../../i18n";

export const LangSwitch = ({ dark = false }) => {
  const { lang, setLang } = useI18n();
  const base = "h-11 min-w-11 px-3 rounded-full text-sm font-semibold transition-colors duration-200";
  const idle = dark ? "text-white/60 hover:text-white" : "text-navy/50 hover:text-navy";
  const active = dark ? "bg-white/15 text-white" : "bg-navy text-white";
  return (
    <div className={`flex items-center rounded-full p-0.5 ${dark ? "bg-white/5" : "bg-white shadow-sm"}`} role="group">
      {["el", "en"].map((code) => (
        <button
          key={code}
          type="button"
          data-testid={`lang-switch-${code}`}
          onClick={() => setLang(code)}
          className={`${base} ${lang === code ? active : idle}`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
